import React from "react";
import { P_Props } from "./PasswordForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, loadCallback } from "../../../utils";
import { TextField } from "@material-ui/core";
import { REGEX } from "../../../constants";

const PasswordFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  return (
    <>
      <div className="password-form">
        <div className="login-form__title">Forgot Password</div>
        <div className="password-form__note">
          Enter your registered email address and we will send you a link to reset your password
        </div>
        <Form
          // initialValues={
          //   props.initData
          //     ? bindingLoginToForm(props.initData)
          //     : {
          //         name: "",
          //         password: "",
          //       }
          // }
          initialValuesEqual={() => true}
          onSubmit={async (values, form) => {
            // props.onSubmit(values);
          }}
          render={({ handleSubmit, form, pristine }) => {
            submit = handleSubmit;
            return (
              <form onSubmit={handleSubmit} className="login-form-input">
                <Field 
                  name="email" 
                  validate={FormUtil.composeValidators([
                    FormUtil.Rule.required("Please input email"),
                    FormUtil.Rule.pattern(REGEX.EMAIL, { errorMessage: "Email format invalid!" }),
                  ])}
                >
                  {({ input, meta, ...rest }) => {
                    return (
                      <TextField
                        {...input}
                        {...rest}
                        fullWidth
                        placeholder="Email"
                        variant="outlined"
                        className="form-text-field"
                        inputProps={{ className: "input" }}
                        onChange={(e) => input.onChange(e.target.value)}
                        helperText={meta.touched ? meta.error : ""}
                        error={meta.error && meta.touched}
                      />
                    );
                  }}
                </Field>
                <button
                  className="login-form__btn-login"
                  onClick={(e) => {
                    e.preventDefault();
                    loadCallback(submit, e);
                  }}
                >
                  Submit
                </button>
              </form>
            );
          }}
        />
      </div>
    </>
  );
};

export default PasswordFormPresenter;
